import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_TRACKERS = Symbol('affiliate.trackers');

export const AFFILIATE_TRACKERS_ROUTE_NAME = Symbol('affiliate.trackers');
export const AFFILIATE_TRACKERS_LIST_ROUTE_NAME = Symbol('affiliate.trackers.list');

export const AFFILIATE_TRACKERS_LIST_API_URL = 'affiliate/trackers/list';
export const AFFILIATE_TRACKERS_LIST_QUERY_KEY = 'affiliate.trackers.list';

export const AFFILIATE_TRACKERS_SAVE_URL = 'affiliate/trackers/:id';
export const AFFILIATE_TRACKERS_SAVE_MUTATION_KEY = 'affiliate.trackers.save';

export const AFFILIATE_TRACKERS_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.TRACKERS_SHOW),
  CREATE: new Permission(undefined, PermissionsList.affiliate.TRACKERS_CREATE),
  EDIT: new Permission(undefined, PermissionsList.affiliate.TRACKERS_EDIT),
  SHOW_CREATIVE: new Permission(undefined, PermissionsList.affiliate.CREATIVES_SHOW),
};
